import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppRouter } from './routes';
import './styles/index.css';
import './styles/theme-overrides.css';

//ReactDOM.createRoot is a function that creates a root element for the React application.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>,
);
